import FeedsTable from "./components/feeds-table";

export default function FeedsPage() {
  return <FeedsTable />;
}
